<template>
  <div>
    <div class="uk-section">
      <div class="uk-container uk-container-small">
      <form @submit.prevent="onSubmit">
         <fieldset class="uk-fieldset">
            <legend class="uk-legend">Ny artikkel</legend>
        <div class="uk-margin">
          <label for="title">Tittel</label>
          <input
                  class="uk-input"
                  type="text"
                  id="title"
                  v-model="title">
        </div>
        <div class="uk-margin">
          <label for="excerpt">Ingress</label>
          <textarea
                  class="uk-textarea"
                  id="excerpt"
                  v-model="excerpt">
          </textarea>
        </div>
        <div class="uk-margin">
          <label for="article">Artikkel</label>
          <textarea
                  class="uk-textarea"
                  id="article"
                  v-model="article">
          </textarea>
        </div>
        <div class="uk-margin">
          <input class="uk-button" type="submit" value="Lagre">
        </div>
        </fieldset>
      </form>
      </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router.js'

  export default {
    data () {
      return {
        title: '',
        excerpt: '',
        article: '',
        author: ''
      }
    },
    methods: {
      onSubmit () {
        const formData = {
          title: this.title,
          excerpt: this.excerpt,
          article: this.article,
          slug: 'AUTOGENERATES',
          author: localStorage.userId
        }
      axios.post('http://localhost:1337/articles', {
        title: formData.title,
        excerpt: formData.excerpt,
        article: formData.article,
        slug: formData.slug,
        author: localStorage.userId
      })
        .then(res => {
          console.log("ArticleDetails: "+res)
          router.push("/article/"+res.slug)
        })
        .catch(error => console.log(error))
        console.log(formData)
      }
    }
  }
</script>

<style scoped>
  .signin-form {
    width: 400px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }
  .input {
    margin: 10px auto;
  }
  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }
  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    border-radius: 7px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }
  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }
  .submit button {
    border: 1px solid #521751;
    color: #521751;
    padding: 10px 20px;
    font: inherit;
    cursor: pointer;
    border-radius: 18px;
  }
  .submit button:hover,
  .submit button:active {
    background-color: #521751;
    color: white;
  }
  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }
</style>